import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Update_Property, putAPI_Update_Subscribed_Property_Products } from '../../../../../../../constants/APIs';
import { PropertyForm } from './PropertyForm';
import GptTemplate from './GptTemplates';
import Validation from '../../../../../../../components/Validation';

export default function UpdatePropertyForm({ id, groupId, gptTemplate, fetchProperties, groupCurrency, propertyTags }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [isGptTemplate, setIsGptTemplate] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleSubmit = (data, applicableProducts) => {
    const formmatedData = { ...data, updater: 'admin' };
    const UpdatedData = { ...applicableProducts, createdBy: 'admin' };
    console.log(formmatedData);
    AxiosAPI({
      method: 'put',
      url: `${postAPI_Update_Property}/${id}`,
      data: formmatedData,
    }).then(
      (res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Subscribed_Property_Products}/${id}`,
            data: UpdatedData,
          })
            .then(
              (res_2) => {
                setVisible(false);
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            );
        }
      }
    );
  };

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      <Button
        className="ml-3"
        color="dark"
        size="sm"
        onClick={() => setIsGptTemplate(true)}
      >
        GPT Template
      </Button>
      {isUpdating && (
        <PropertyForm
          formLabel="Update Property"
          visible={isUpdating}
          propertyTags={propertyTags}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          groupId={groupId}
          groupCurrency={groupCurrency}

        />
      )}
      {isGptTemplate &&
        <GptTemplate
          id={id}
          visible={isGptTemplate}
          toggle={() => setIsGptTemplate(false)}
          gptTemplate={gptTemplate}
          fetchProperties={fetchProperties}>
        </GptTemplate>
      }
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}
